<template>
  <Modal
    :title="titleModal"
    :show-modal="title === 'create' || title === 'edit'"
    class="h-[30rem] my-auto !w-[60rem] mx-auto"
    @close="$emit('on-close')"
  >
    <div class="flex flex-col mb-5">
      <Input
        name="description"
        :label="'Description'"
        :value="formOutputfile.description"
        :label-top="true"
        @input="($event) => onInputDescription($event)"
        placeholder="Input Descripion"
        class="!mb-0"
        :input_class="v$.description.$error ? '!outline-red-500' : null"
      />
      <span
        class="text-xs font-bold text-red-500"
        v-if="v$.description.$error"
        >{{ messageErrorDescription }}</span
      >
    </div>
    <div class="flex flex-col">
      <Select
        name="typeFile"
        label="Tipe File"
        :label-top="true"
        :options="typeFiles"
        :value="formOutputfile.typeFile"
        property="label"
        @change="($event) => onChangeTypeFile($event)"
        select_property="value"
      />
      <span class="text-xs font-bold text-red-500" v-if="v$.typeFile.$error">{{
        messageErrorTypeFile
      }}</span>
    </div>
    <template v-slot:footer>
      <section class="flex flex-row justify-end gap-x-2 w-52">
        <Button
          class="w-24 py-2 text-white bg-gray-400 rounded-md"
          @click="$emit('on-close')"
        >
          Close
        </Button>
        <Button
          class="w-24 py-2 text-white bg-green-500 rounded-md"
          :disabled="disableSubmit"
          @click="$emit('on-submit')"
        >
          {{ formOutputfile.id !== null ? "Update" : "Add" }}
        </Button>
      </section>
    </template>
  </Modal>
</template>

<script>
import { ref } from "vue";
import Modal from "@/components/Modal.vue";
import Input from "@/components/Input.vue";
import Select from "@/components/Select/index.vue";
import { useVuelidate } from "@vuelidate/core";
import { required, minLength, alpha } from "@vuelidate/validators";

export default {
  name: "ModalFormOutputFile",
  props: {
    title: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    typeFiles: {
      type: Array,
      required: true,
    },
    typeFile: {
      type: String,
      required: true,
    },
  },
  components: {
    Modal,
    Input,
    Select,
  },
  setup() {
    const v$ = useVuelidate();
    const formOutputfile = ref({
      id: null,
      description: "",
      typeFile: "",
    });
    return {
      v$,
      formOutputfile,
    };
  },
  validations() {
    return {
      description: { required, minLengthValue: minLength(5), alpha },
      typeFile: { required },
    };
  },
  watch: {
    id: {
      handler(value) {
        this.formOutputfile.id = value;
      },
      deep: true,
    },
    description: {
      handler(value) {
        this.formOutputfile.description = value;
      },
      deep: true,
    },
    typeFile: {
      handler(value) {
        this.formOutputfile.typeFile = value;
      },
      deep: true,
    },
  },
  computed: {
    titleModal() {
      if (this.title === "create") {
        return "Add Ouput File";
      } else if (this.title === "edit") {
        return "Edit Ouput File";
      } else {
        return "";
      }
    },
    messageErrorDescription() {
      if (this.v$.description.required.$invalid) {
        return "Deskripsi tidak boleh kosong";
      } else if (this.v$.description.alpha.$invalid) {
        return "Deskripsi harus berupa huruf";
      } else if (this.v$.description.minLengthValue.$invalid) {
        return "Deskripsi minimal harus 5 karakter";
      } else {
        return "";
      }
    },
    messageErrorTypeFile() {
      if (this.v$.typeFile.required.$invalid) {
        return "Tipe file tidak boleh kosong";
      } else {
        return "";
      }
    },
    disableSubmit() {
      if (this.v$.$invalid) {
        return true;
      }

      return false;
    },
  },
  methods: {
    onInputDescription($event) {
      this.$emit("update:description", $event);
      this.v$.description.$touch();
    },
    onChangeTypeFile($event) {
      this.$emit("update:type-file", $event);
      this.v$.typeFile.$touch();
    },
  },
};
</script>
